import './styles/quasar.sass'
import '@quasar/extras/material-icons/material-icons.css'

export default {
  config: {},
  plugins: {
  }
}